/**
 * Squarespace pages — proxy only, no locale logic
 * Legacy Squarespace pages proxied through middleware's proxy.ts
 * All are single root-level segments: also seed reserved-slug set (i18n/reservedSlugs.ts)
 * Transitional: shrinks as pages migrate off Squarespace and is removed at the end of the i18n epic
 * providing all pages are migrated into [lang]
 */
export const SQUARESPACE_PAGES: readonly string[] = [
  '/bucketlisttrips',
  '/byway-magazine',
  '/cart',
  '/confirmation',
  '/contact-dog',
  '/events-and-rerouting',
  '/fallback',
  '/flight-free-made-easy',
  '/oops-sorry',
  '/short-breaks-europe',
  '/stories',
  '/trends',
  '/trip-book-enquiry',
  '/trip-edit-enquiry',
  '/trip-no-longer-available'
];
